module.exports = __webpack_public_path__ + "img/index1.8997f875.png";